/* eslint-disable camelcase */
export default {
  empty: 'No links have been added to the slider component',
};
